$ ->
  $codeInput = $("#promo_code_code")
  $countInput = $("#promo_code_count")

  toggleInputs = ->
    if $.trim($codeInput.val()) isnt ""
      $countInput.prop "disabled", true
    else
      $countInput.prop "disabled", false

    if $countInput.val() isnt "" and parseInt($countInput.val()) > 0
      $codeInput.prop "disabled", true
    else
      $codeInput.prop "disabled", false

  $codeInput.on "input", toggleInputs
  $countInput.on "input", toggleInputs
